export default __webpack_public_path__ + "static/media/multiplayer onderzoeksrapport.99999685.pdf";